/* ------------------------------------------------------------------
   RAVA - ENGLISH THEME STRINGS

   Generated from the theme's own locales/hu.json and
   locales/en.default.json. Do not edit by hand: rebuild it with
   scratchpad/build-langmap.ps1 if the locale files change.

   Shopify's store language is Hungarian, so every string the theme
   renders through the translation filter comes out Hungarian even
   when the site is showing English. This is the lookup used to put
   those back into English at runtime.
   ------------------------------------------------------------------ */
window.RAVA_EN_STRINGS = {
  "Elküldtük a hozzászólásodat. Blogunkat moderáljuk, ezért egy kis idő múlva tesszük csak közzé a hozzászólást.": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.",
  "Tartalmazza a vámokat és az adókat. A kedvezményeket és a szállítási költséget a megrendeléskor számítjuk ki.": "Duties and taxes included. Discounts and shipping calculated at checkout.",
  "Te vagy a webáruház tulajdonosa? <a href=\"/admin\" class=\"link underlined-link\">Itt tudsz bejelentkezni</a>": "Are you the store owner? <a href=\"/admin\" class=\"link underlined-link\">Log in here</a>",
  "Tartalmazza a vámokat. Az adókat, a kedvezményeket és a szállítási költséget a megrendeléskor számítjuk ki": "Duties included. Taxes, discounts and shipping calculated at checkout.",
  "Tartalmazza az adókat. A kedvezményeket és a szállítási költséget a megrendeléskor számítjuk ki.": "Taxes included. Discounts and shipping calculated at checkout.",
  "Megtekintés a saját környezetben: kiterjesztettvalóság-alapú ablakban töltődik be az elem": "View in your space, loads item in augmented reality window",
  "Felhívjuk a figyelmedet, hogy a hozzászólásokat jóvá kell hagyni a közzétételük előtt.": "Please note, comments need to be approved before they are published.",
  "Az adókat, a kedvezményeket és a szállítási költséget a megrendeléskor számítjuk ki": "Taxes, discounts and shipping calculated at checkout.",
  "Köszönjük, hogy írtál nekünk. A lehető legrövidebb időn belül válaszolni fogunk.": "Thanks for contacting us. We'll get back to you as soon as possible.",
  "Az ajándékkártya kódja online, a QR-kód pedig az üzletben használható fel": "Use the gift card code online or QR code in-store",
  "Itt foglalhatod össze a vásárlóidnak, miről szól a blogbejegyzésed": "Give your customers a summary of your blog post",
  "E-mailben elküldtük a jelszó módosításához szükséges hivatkozást.": "We've sent you an email with a link to update your password.",
  "Küldünk egy e-mailt, amellyel új jelszót készíthetsz magadnak.": "We will send you an email to reset your password",
  "Ezt a QR-kódot beszkennelve beválthatod az ajándékkártyát.": "QR code — scan to redeem gift card",
  "Ha kiválasztasz egy lehetőséget, a teljes oldal frissül.": "Choosing a selection results in a full page refresh.",
  "Hiba történt a kosár frissítése közben. Próbálkozz újra.": "There was an error while updating your cart. Please try again.",
  "Nem sikerült betölteni az átvehetőségi adatokat": "Couldn't load pickup availability",
  "Ajándékkártya címzettjének űrlapja összecsukva": "Gift card recipient form collapsed",
  "A fiók aktiválásához hozz létre egy jelszót.": "Create your password to activate your account.",
  "Eltávolítod ezt a(z) 1 terméket a kosárból?": "Remove 1 item from your cart?",
  "Ajándékkártya címzettjének űrlapja kibontva": "Gift card recipient form expanded",
  "A változat elfogyott vagy nincs készleten": "Variant sold out or unavailable",
  "Megjegyzések a rendeléssel kapcsolatban": "Order special instructions",
  "Elküldtük a hozzászólásodat. Köszönjük!": "Your comment was posted successfully! Thank you!",
  "Mennyiségi árszabás rendelkezésre áll": "Volume pricing available",
  "Kihagyás, és ugrás a termékadatokra": "Skip to product information",
  "Kérjük, helyesbítsd a következőket:": "Please adjust the following:",
  "Tartalmazza a vámokat és az adókat.": "Duties and taxes included.",
  "A vágólapra másoltuk a hivatkozást.": "Link copied to clipboard",
  "Címzett e-mail-címe (nem kötelező)": "Recipient email (optional)",
  "Beállítás alapértelmezett címként": "Set as default address",
  "Mennyiségi szabályok megtekintése": "View quantity rules",
  "Megtekintés a saját környezetben": "View in your space",
  "Tartalom megnyitása új ablakban.": "Opens in a new window.",
  "Belépés a webáruházba jelszóval:": "Enter store using password:",
  "Ajándékkártya kódjának másolása": "Copy gift card code",
  "Betettük a terméket a kosárba": "Item added to your cart",
  "Lejátszás a 3D-megjelenítőben": "Play 3D Viewer",
  "Hivatkozás a csomagkövetéshez": "Tracking link",
  "Biztos, hogy törlöd a címet?": "Are you sure you wish to delete this address?",
  "Hozzáadás az Apple Wallethoz": "Add to Apple Wallet",
  "Elfelejtetted a jelszavadat?": "Forgot your password?",
  "Küldés dátuma (nem kötelező)": "Send on (optional)",
  "Minden részlet megtekintése": "View full details",
  "Válassz a lehetőségek közül": "Choose options",
  "Kapható más webáruházakban?": "Check availability at other stores",
  "Ajándékba szeretném küldeni": "I want to send this as a gift",
  "Címzett neve (nem kötelező)": "Recipient name (optional)",
  "Sikeres volt a kód másolása": "Code copied successfully",
  "Külső webhelyet nyit meg.": "Opens external website.",
  "Új fiókjelszó létrehozása": "Reset account password",
  "Köszönjük a feliratkozást": "Thanks for subscribing",
  "Még nem rendeltél semmit.": "You haven't placed any orders yet.",
  "Közzététel a Pinteresten": "Pin on Pinterest",
  "Népszerű országok/régiók": "Popular countries/regions",
  "Ország/régió frissítése": "Update country/region",
  "Téves jelszót írtál be.": "Wrong password!",
  "Az összesnek megfelelő": "Match all",
  "Az összes megtekintése": "View all",
  "Kosárban lévő termékek": "Cart items",
  "Tartalmazza az adókat.": "Taxes included.",
  "Vissza a fiókadatokhoz": "Return to Account details",
  "Nem találjuk az oldalt": "Page not found",
  "Megosztás a Facebookon": "Share on Facebook",
  "Összecsukható tartalom": "Collapsible content",
  "Diavetítés megállítása": "Pause slideshow",
  "Tartalmazza a vámokat.": "Duties included.",
  "Az összes eltávolítása": "Remove all",
  "Hozzászólás elküldése": "Post comment",
  "Új jelszó létrehozása": "Reset your password",
  "Betöltés folyamatban…": "Loading...",
  "Üzenet (nem kötelező)": "Message (optional)",
  "Kapcsolattartói űrlap": "Contact form",
  "Hozzáadás a kosárhoz": "Add to cart",
  "Írd be az új jelszót": "Enter a new password",
  "404-es hiba történt.": "404",
  "Folytatás vendégként": "Continue as a guest",
  "Meghívás elutasítása": "Decline invitation",
  "Személyesen átvehető": "Pickup available",
  "Új becsült végösszeg": "New estimated total",
  "Webáruház megnyitása": "Visit online store",
  "Megosztás befejezése": "Close share",
  "Jelszó megerősítése": "Confirm password",
  "Következő közlemény": "Next announcement",
  "A termék megosztása": "Share this product",
  "Ugrás a tartalomhoz": "Skip to content",
  "Címzett e-mail-címe": "Recipient email",
  "Diavetítés indítása": "Play slideshow",
  "Kiegészítő termékek": "Complementary products",
  "Új jelszó készítése": "Reset password",
  "Mennyiségi árszabás": "Volume Pricing",
  "Ajándékkártya kódja": "Gift card code",
  "Hivatkozás másolása": "Copy link",
  "Teljesítési állapot": "Fulfillment status",
  "Rendezési szempont:": "Sort by:",
  "Vásárlás folytatása": "Continue shopping",
  "Galériamegjelenítő": "Gallery Viewer",
  "Címek megtekintése": "View addresses",
  "Szűrés és rendezés": "Filter and sort",
  "Kosár megtekintése": "View cart",
  "Korábbi rendelések": "Order history",
  "Termék részösszege": "Product subtotal",
  "Szűrő eltávolítása": "Remove filter",
  "Becsült végösszeg": "Estimated total",
  "Példa terméknévre": "Example product title",
  "Hozzászólás írása": "Leave a comment",
  "Belépés jelszóval": "Enter using password",
  "Új cím hozzáadása": "Add a new address",
  "Megosztás az X-en": "Share on X",
  "Keresőszó törlése": "Clear search term",
  "Változat összesen": "Variant total",
  "Fiók létrehozása": "Create account",
  "Kevesebb részlet": "Show less",
  "Nyelv módosítása": "Update language",
  "Termékváltozatok": "Product variants",
  "Cím szerkesztése": "Edit address",
  "Alacsony készlet": "Low stock",
  "Videó lejátszása": "Play video",
  "összes értékelés": "total reviews",
  "Webáruház adatai": "View store information",
  "Fizetési állapot": "Payment status",
  "Nincs készleten": "Unavailable",
  "Alapértelmezett": "Default",
  "Már van fiókod?": "Have an account?",
  "Vissza a blogba": "Back to blog",
  "Következő oldal": "Next page",
  "Fiók aktiválása": "Activate account",
  "Előző közlemény": "Previous announcement",
  "Cikk megosztása": "Share this article",
  "Futárszolgálat": "Carrier",
  "Számlázási cím": "Billing Address",
  "Termékváltozat": "SKU",
  "Fizetési módok": "Payment methods",
  "Cím frissítése": "Update address",
  "A kosarad üres": "Your cart is empty",
  "Szállítási cím": "Shipping Address",
  "Kollekció neve": "Your collection's name",
  "Felhasználónév": "Login",
  "Cím hozzáadása": "Add address",
  "Fuvarlevélszám": "Tracking number",
  "Visszatérítve": "Refunded",
  "Kijelentkezés": "Log out",
  "Ajándékkártya": "Your gift card",
  "Csomagkövetés": "Track shipment",
  "Blogbejegyzés": "Blog post",
  "Nincs találat": "No products found",
  "Következő dia": "Slide right",
  "Dia betöltése": "Load slide",
  "Összes termék": "Total items",
  "Bejelentkezés": "Log in",
  "Feliratkozás": "Subscribe",
  "Több részlet": "Show more",
  "Ország/régió": "Country/region",
  "Saját jelszó": "Your password",
  "Irányítószám": "Postal/ZIP code",
  "Közleménysáv": "Announcement bar",
  "Megrendelés": "Check out",
  "Szerkesztés": "Edit",
  "Termék képe": "Product image",
  "Hozzászólás": "Comment",
  "Előző oldal": "Previous page",
  "Forgalmazó:": "Vendor:",
  "Telefonszám": "Phone number",
  "Alaphelyzet": "Reset",
  "Javaslatok": "Suggestions",
  "Forgalmazó": "Vendor",
  "Kedvezmény": "Discount",
  "Részösszeg": "Subtotal",
  "ÉÉÉÉ-HH-NN": "YYYY-MM-DD",
  "Oldal címe": "Page title",
  "Létrehozás": "Create",
  "Hivatkozás": "Link",
  "Vezetéknév": "Last name",
  "Fiókadatok": "Account details",
  "E-mail-cím": "Email",
  "Akciós ár": "Sale price",
  "Előző dia": "Slide left",
  "Normál ár": "Regular price",
  "Mennyiség": "Quantity",
  "Frissítés": "Refresh",
  "Település": "City",
  "Szállítás": "Shipping",
  "Elfogyott": "Sold out",
  "Találatok": "Search results",
  "Kollekció": "Collection",
  "Végösszeg": "Total",
  "Közlemény": "Announcement",
  "Rendezés": "Sort",
  "Változat": "Variant",
  "Forgótár": "Carousel",
  "Egységár": "Unit price",
  "Tördelés": "Pagination",
  "Médiatár": "Media gallery",
  "Alkalmaz": "Apply",
  "Termékek": "Products",
  "Raktáron": "In stock",
  "Csúszka": "Slider",
  "Belépés": "Enter",
  "Szűrés:": "Filter:",
  "Bezárás": "Close",
  "Keresés": "Search",
  "Leírás": "Description",
  "Utónév": "First name",
  "Termék": "Product",
  "1. cím": "Address 1",
  "2. cím": "Address 2",
  "Ettől:": "From",
  "Akciós": "Sale",
  "Szűrés": "Filter",
  "Cégnév": "Company",
  "Jelszó": "Password",
  "Üzenet": "Message",
  "Küldés": "Send",
  "Lejárt": "Expired",
  "Törlés": "Clear",
  "Tovább": "Continue",
  "Eddig:": "To",
  "Kosár": "Cart",
  "Oldal": "Page",
  "Vámok": "Duties",
  "Nyelv": "Language",
  "Megye": "Province",
  "Címek": "Addresses",
  "Mégse": "Cancel",
  "Dátum": "Date",
  "Fiók": "Account",
  "vagy": "or",
  "Hiba": "Error",
  "Menü": "Menu",
};

/* Labels built around a value, such as a product name. Matched as
   patterns because the rendered text is never the same twice. */
window.RAVA_EN_PATTERNS = [
  { re: "^A\\ bolt\\ szolgáltatója\\ a\\ (.+)$", to: "This shop will be powered by $1" },
  { re: "^(.+?)\\.\\ oldal$", to: "Page $1" },
  { re: "^Kosár\\ megtekintése\\ \\((.+?)\\)$", to: "View cart ($1)" },
  { re: "^(.+?)/(.+?)\\ csillag$", to: "$2 out of $1 stars" },
  { re: "^Továbbiak:\\ (.+)$", to: "Read more: $1" },
  { re: "^(.+?)\\ hozzászólás$", to: "$1 comment" },
  { re: "^(.+?)\\ hozzászólás$", to: "$1 comments" },
  { re: "^(.+?)\\ mennyisége$", to: "Quantity for $1" },
  { re: "^(.+?)\\ mennyiségének\\ növelése$", to: "Increase quantity for $1" },
  { re: "^(.+?)\\ mennyiségének\\ csökkentése$", to: "Decrease quantity for $1" },
  { re: "^Minimum:\\ (.+)$", to: "Minimum of $1" },
  { re: "^Maximum:\\ (.+)$", to: "Maximum of $1" },
  { re: "^Növekvés:\\ (.+)$", to: "Increments of $1" },
  { re: "^Kosárban\\ lévő\\ mennyiség:\\ <span\\ class=\"quantity-cart\">(.+?)</span>$", to: "<span class=\"quantity-cart\">$1</span> in cart" },
  { re: "^Min\\.\\ (.+)$", to: "Min $1" },
  { re: "^Max\\.\\ (.+)$", to: "Max $1" },
  { re: "^Mennyiség\\ \\((.+?)\\ a\\ kosárban\\)$", to: "Quantity ($1 in cart)" },
  { re: "^Legalacsonyabb\\ ár:\\ (.+)$", to: "From $1" },
  { re: "^(.+?):\\ a\\ teljes\\ képernyős\\ videó\\ ugyanabban\\ az\\ ablakban\\ nyílik\\ meg\\.$", to: "$1 opens full screen video in same window." },
  { re: "^Személyesen\\ átvehető\\ itt:\\ <span\\ class=\"color-foreground\">(.+?)</span>$", to: "Pickup available at <span class=\"color-foreground\">$1</span>" },
  { re: "^Személyesen\\ egyelőre\\ nem\\ vehető\\ át\\ itt:\\ <span\\ class=\"color-foreground\">(.+?)</span>$", to: "Pickup currently unavailable at <span class=\"color-foreground\">$1</span>" },
  { re: "^(.+?)\\.\\ médiafájl\\ megnyitása\\ a\\ modális\\ párbeszédpanelen$", to: "Open media $1 in modal" },
  { re: "^(.+?)\\.\\ kép\\ betöltése\\ galérianézetben$", to: "Load image $1 in gallery view" },
  { re: "^(.+?)\\.\\ térhatású\\ modell\\ betöltése\\ galérianézetben$", to: "Load 3D Model $1 in gallery view" },
  { re: "^(.+?)\\.\\ videó\\ lejátszása\\ galérianézetben$", to: "Play video $1 in gallery view" },
  { re: "^(.+?)\\.\\ kép\\ betöltve\\ galérianézetben$", to: "Image $1 is now available in gallery view" },
  { re: "^(.+?)\\ –\\ (.+)$", to: "$1 for $2" },
  { re: "^A\\ <a\\ href=\"(.+?)\">szállítási\\ költséget</a>\\ a\\ megrendeléskor\\ számítjuk\\ ki\\.$", to: "<a href=\"$1\">Shipping</a> calculated at checkout." },
  { re: "^Termékváltozatok\\ –\\ (.+)$", to: "Choose options for $1" },
  { re: "^(.+?)\\ –\\ Nincs\\ készleten$", to: "$1 - Unavailable" },
  { re: "^(.+?)\\ raktáron$", to: "$1 in stock" },
  { re: "^Alacsony\\ készlet:\\ csak\\ (.+?)\\ van\\ raktáron$", to: "Low stock: $1 left" },
  { re: "^(.+?)\\ –\\ (.+)$", to: "$1 - $2" },
  { re: "^(.+?)/db$", to: "at $1/ea" },
  { re: "^(.+?)\\ elem\\ kijelölve$", to: "$1 selected" },
  { re: "^(.+?)\\ elem\\ kijelölve$", to: "$1 selected" },
  { re: "^A\\ legmagasabb\\ ár\\ (.+)$", to: "The highest price is $1" },
  { re: "^(.+?)/(.+?)\\ termék$", to: "$2 of $1 product" },
  { re: "^(.+?)/(.+?)\\ termék$", to: "$2 of $1 products" },
  { re: "^(.+?)\\ termék$", to: "$1 product" },
  { re: "^(.+?)\\ termék$", to: "$1 products" },
  { re: "^(.+?)\\ \\((.+?)\\ szűrő\\ kiválasztva\\)$", to: "$1 ($2 filters selected)" },
  { re: "^Nincs\\ találat\\ erre:\\ (.+?)\\.\\ Ellenőrizd\\ a\\ helyesírást,\\ vagy\\ írj\\ be\\ egy\\ másik\\ szót\\ vagy\\ kifejezést\\.$", to: "No results found for “$1”. Check the spelling or use a different word or phrase." },
  { re: "^(.+?)\\ találat$", to: "$1 result" },
  { re: "^(.+?)\\ találat$", to: "$1 results" },
  { re: "^Keresés\\ erre:\\ (.+)$", to: "Search for “$1”" },
  { re: "^(.+?)\\ találat\\ erre:\\ (.+)$", to: "$1 result found for “$2”" },
  { re: "^(.+?)\\ találat\\ erre:\\ (.+)$", to: "$1 results found for “$2”" },
  { re: "^(.+?)\\ oldal$", to: "$1 page" },
  { re: "^(.+?)\\ oldal$", to: "$1 pages" },
  { re: "^(.+?)\\ javaslat$", to: "$1 suggestion" },
  { re: "^(.+?)\\ javaslat$", to: "$1 suggestions" },
  { re: "^(.+?)\\ termék$", to: "$1 product" },
  { re: "^(.+?)\\ termék$", to: "$1 products" },
  { re: "^(.+?)\\ elem$", to: "$1 item" },
  { re: "^(.+?)\\ elem$", to: "$1 items" },
  { re: "^(.+?)\\ eltávolítása$", to: "Remove $1" },
  { re: "^Ebből\\ a\\ termékből\\ legfeljebb\\ (.+?)\\ darabot\\ rakhatsz\\ a\\ kosárba\\.$", to: "You can only add $1 of this item to your cart." },
  { re: "^<a\\ href=\"(.+?)\"\\ class=\"link\\ underlined-link\">Jelentkezz\\ be</a>\\ a\\ gyorsabb\\ fizetéshez\\.$", to: "<a href=\"$1\" class=\"link underlined-link\">Log in</a> to check out faster." },
  { re: "^Tartalmazza\\ a\\ vámokat\\ és\\ az\\ adókat\\.\\ A\\ kedvezményeket\\ és\\ a\\ <a\\ href=\"(.+?)\">szállítási\\ költséget</a>\\ a\\ megrendeléskor\\ számítjuk\\ ki\\.$", to: "Duties and taxes included. Discounts and <a href=\"$1\">shipping</a> calculated at checkout." },
  { re: "^Tartalmazza\\ az\\ adókat\\.\\ A\\ kedvezményeket\\ és\\ a\\ <a\\ href=\"(.+?)\">szállítási\\ költséget</a>\\ a\\ megrendeléskor\\ számítjuk\\ ki\\.$", to: "Taxes included. Discounts and <a href=\"$1\">shipping</a> calculated at checkout." },
  { re: "^Tartalmazza\\ a\\ vámokat\\.\\ Az\\ adókat,\\ a\\ kedvezményeket\\ és\\ a\\ <a\\ href=\"(.+?)\">szállítási\\ költséget</a>\\ a\\ megrendeléskor\\ számítjuk\\ ki\\.$", to: "Duties included. Taxes, discounts and <a href=\"$1\">shipping</a> calculated at checkout." },
  { re: "^Az\\ adókat,\\ a\\ kedvezményeket\\ és\\ a\\ <a\\ href=\"(.+?)\">szállítási\\ költséget</a>\\ a\\ megrendeléskor\\ számítjuk\\ ki\\.$", to: "Taxes, discounts and <a href=\"$1\">shipping</a> calculated at checkout." },
  { re: "^Az\\ ebben\\ a\\ kollekcióban\\ szereplő\\ összes\\ termék\\ megtekintése:\\ (.+)$", to: "View all products in the $1 collection" },
  { re: "^Használj\\ kevesebb\\ szűrőt,\\ vagy\\ <a\\ class=\"(.+?)\"\\ href=\"(.+?)\">távolítsd\\ el\\ az\\ összeset</a>\\.$", to: "Use fewer filters or <a class=\"$1\" href=\"$2\">remove all</a>" },
  { re: "^Videó\\ betöltése:\\ (.+)$", to: "Load video: $1" },
  { re: "^(.+?)/db$", to: "$1/ea" },
  { re: "^(.+?)\\ termék\\ hozzáadva$", to: "$1 item added" },
  { re: "^(.+?)\\ termék\\ hozzáadva$", to: "$1 items added" },
  { re: "^(.+?)\\ termék\\ eltávolítva$", to: "$1 item removed" },
  { re: "^(.+?)\\ termék\\ eltávolítva$", to: "$1 items removed" },
  { re: "^Eltávolítod\\ mind\\ a\\(z\\)\\ (.+?)\\ terméket\\ a\\ kosárból\\?$", to: "Remove all $1 items from your cart?" },
  { re: "^A\\ termék\\ minimális\\ mennyisége\\ (.+)$", to: "This item has a minimum of $1" },
  { re: "^A\\ termék\\ maximális\\ mennyisége\\ (.+)$", to: "This item has a maximum of $1" },
  { re: "^A\\ termék\\ mennyisége\\ csak\\ (.+?)\\ darabos\\ lépésekben\\ növelhető$", to: "You can only add this item in increments of $1" },
  { re: "^(.+?)\\ ország/régió\\ található$", to: "$1 countries/regions found" },
  { re: "^Rendelés\\ száma:\\ (.+)$", to: "Order number $1" },
  { re: "^Megrendelés:\\ (.+)$", to: "Order $1" },
  { re: "^Megrendelés\\ dátuma:\\ (.+)$", to: "Placed on $1" },
  { re: "^Megrendelés\\ lemondva:\\ (.+)$", to: "Order Cancelled on $1" },
  { re: "^Ok:\\ (.+)$", to: "Reason: $1" },
  { re: "^Teljesítés\\ dátuma:\\ (.+)$", to: "Fulfilled $1" },
  { re: "^Íme\\ a\\(z\\)\\ (.+?)\\ üzletben\\ levásárolható,\\ (.+?)\\ értékű\\ ajándékkártyád!$", to: "Here's your $2 gift card balance for $1!" },
  { re: "^Lejárat\\ dátuma:\\ (.+)$", to: "Expires $1" },
  { re: "^Maximum\\ (.+?)\\ karakter$", to: "$1 characters max" },
];
